<template>
  <div class="container">
    <MainMenu v-bind:whiteNav="this.$route.path == '/'" @pullSheetClick='showPullSheet = !showPullSheet, showAccount = false' @accountClick='showAccount = !showAccount, showPullSheet = false' />
      <div class="content" @click="showAccount = false, showPullSheet = false">
        <router-view></router-view>
        <MainFooter v-on:showEmailSignup="showEmailModal = true" />
      </div>
      <PullSheet v-bind:class="{ floating: this.$route.path == '/' }" v-bind:showing="showPullSheet" v-on:itemAdded="pullSheetAdded" />
      <Account v-bind:class="{ floating: this.$route.path == '/' }" v-bind:showing="showAccount" />
      <div class="mailinglistmodal" v-if="showEmailModal" @click.self="showEmailModal=false">
          <div class="inner">
              <i class="closebutton material-icons" @click="showEmailModal=false">close</i>
              <h3>Join Our List</h3>
              <p>Sign up for occasional updates on what's new with The Renees</p>
              <div id="mc_embed_signup">
                 <form action="https://therenees.us20.list-manage.com/subscribe/post?u=084950bde6a918c733cc08aad&amp;id=69d8eb67cc" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate @submit="emailSubmit($event)">
                    <div id="mc_embed_signup_scroll">
                       <div class="mc-field-group">
                          <label for="mce-EMAIL" >Email Address</label>
                          <input type="email" value="" name="EMAIL" placeholder="Email Address" class="required email" id="mce-EMAIL" v-model="signupemail">
                       </div>
                       <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                       <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_084950bde6a918c733cc08aad_69d8eb67cc" tabindex="-1" value=""></div>
                       <div class="emailerror" v-if="signuperrormessage">{{signuperrormessage}}</div>
                       <div class="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button"></div>
                    </div>
                 </form>
              </div>
           </div>
        </div>

  </div>
</template>

<script>
import MainMenu from './MainMenu'
import MainFooter from './MainFooter'
import PullSheet from './PullSheet'
import Account from './Account'
export default {
  name: 'Site',
  components: {
    MainMenu,
    MainFooter,
    PullSheet,
    Account
  },
  data () {
    return {
      showPullSheet: false,
      showAccount: false,
      showEmailModal: false,
      signupemail: '',
      signuperrormessage: false
    }
  },
  methods: {
    pullSheetAdded: function () {
      this.showPullSheet = true
    },
    emailSubmit (e) {
      if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.signupemail)) {
        setTimeout(() => {
          this.showEmailModal = false
        }, 50)
        return true
      } else {
        e.preventDefault()
        this.signuperrormessage = 'Please enter a valid email address'
        return false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../styles/_mixins.scss";
h1, h2 {
  font-weight: normal;
}

div.content {
}
</style>
<style scoped lang="scss">
@import "../styles/_mixins.scss";
.mailinglistmodal {
  position: fixed;
  top: 0px;
  left: 0px;
  background: rgba(0,0,0,.6);
  width: 100%;
  height: 100%;
  z-index: 1000;
  text-align: center;
  color: #FFF;
    font-family: $futura;
  font-size: 12px;

  .inner {
    background: #7c4682;
    width: 90%;
    max-width: 600px;
    box-sizing: border-box;
    padding: 3em;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    @include bp(most) {
      padding: 4em;
    }
    h3 {
      text-transform: uppercase;
      font-size: 1.5em;
      margin: 0;
    }
    p {
      margin: 1em 0;
      font-size: 1.25em;
    }
    label {
      display: block;
      margin: .5em;
      color: #b48fb4;
    }
    .mc-field-group {
      margin-bottom: 1em;
    }
    input[type='email'] {
      width: 100%;
      border: 0px none;
      padding: 12px;
      font-family: $futura;
      box-sizing: border-box;
      font-size: 14px;
      text-align: center;
    }
    input[type='submit'] {
      background: #a562a5;
      color: #FFF;
      border: 0px none;
      padding: 12px 24px;
      font-family: $futura;
      text-transform: uppercase;
      font-size: 1.25em;
      cursor: pointer;
      &:hover {
        background: #e984e9;
      }
    }
    .closebutton {
      position: absolute;
      right: 4px;
      top: 4px;
      cursor: pointer;
      color: #c38fc3;
    }
    .emailerror {
      color: #ffcbcb;
      font-weight: bold;
      font-size: 14px;
      margin-bottom: 0.75em;
    }
  }
}

</style>



// WEBPACK FOOTER //
// Site.vue?76f3024d